// eslint-disable-next-line no-unused-vars
const production = {
  API: {
    endpoints: [
      {
        name: "SupplyHubSharedAPI",
        endpoint:
          "https://1dvv3r6f04.execute-api.eu-west-2.amazonaws.com/production",
        region: "eu-west-2",
      },
      {
        name: "ManabaAPI",
        endpoint: (process.env.REACT_APP_MANABA_API_URL || "http://localhost:3099").replace(/\/$/, ''),
      },
    ],
  },
  Auth: {
    identityPoolId: "eu-west-2:7d0fee4a-0e43-4a3d-8ee7-ce515376c788", //REQUIRED - Amazon Cognito Identity Pool ID
    region: "eu-west-2", // REQUIRED - Amazon Cognito Region
    userPoolId: "eu-west-2_b7F1SBTWy", //OPTIONAL - Amazon Cognito User Pool ID
    userPoolWebClientId: "4rjunc3btnv6m0nsidhe3ofkt1", //OPTIONAL - Amazon Cognito Web Client ID
  },
  Storage: {
    AWSS3: {
      bucket: "supplyhubstorage142502-production", //REQUIRED -  Amazon S3 bucket name
      region: "eu-west-2", //OPTIONAL -  Amazon service region
    },
  },
};

// eslint-disable-next-line no-unused-vars
const development = {
  API: {
    endpoints: [
      {
        name: "SupplyHubSharedAPI",
        endpoint: "https://2n1843gu7i.execute-api.eu-west-2.amazonaws.com/test",
        region: "eu-west-2",
      },
      {
        name: "ManabaAPI",
        endpoint: (process.env.REACT_APP_MANABA_API_URL || "http://localhost:3099").replace(/\/$/, ''),
      },
    ],
  },
  Auth: {
    identityPoolId: "eu-west-2:7d0fee4a-0e43-4a3d-8ee7-ce515376c788", //REQUIRED - Amazon Cognito Identity Pool ID
    region: "eu-west-2", // REQUIRED - Amazon Cognito Region
    userPoolId: "eu-west-2_b7F1SBTWy", //OPTIONAL - Amazon Cognito User Pool ID
    userPoolWebClientId: "4rjunc3btnv6m0nsidhe3ofkt1", //OPTIONAL - Amazon Cognito Web Client ID
  },
  Storage: {
    AWSS3: {
      bucket: "supplyhubstorage142502-production", //REQUIRED -  Amazon S3 bucket name
      region: "eu-west-2", //OPTIONAL -  Amazon service region
    },
  },
};

export default production;
